import React, { Component } from 'react'
import { connect } from 'react-redux'
import detectBrowserLanguage from 'detect-browser-language'

import { SocketContext, socket } from "./SocketContext"

const values = {
  errors : {
    auth : {
      "fr" : "Vous avez été déconnecté, redirection dans 10 secondes",
      "en" : "You have been disconnected, redirecting in 10 seconds",
    },
  },
  global : {
    click : {
      "fr": "Clique ici",
      "en" : "Click here",
    },
    error : {
      "fr": "Une erreur est survenue, contactez-nous",
      "en" : "An error has occurred, contact us",
    },
  },
  noDataMapping : {
    "fr" : "Aucune donnée à afficher pour le moment.",
    "en" : "No data to display at this moment.",
  },
  noDataCompletionChart : {
    "fr" : "Encore un peu de patience... le suivi sera disponible dès l’ouverture du module 2.",
    "en" : "Just a little more patience... monitoring will be available as soon as module 2 opens.",
  },
  logout : {
    title : {
      "fr": "Déconnexion",
      "en" : "Logout",
    },
  },
  login : { //login page
    title : {
      "fr": "Connexion",
      "en" : "Login",
    },
    emailField : {
      "fr" : "Votre email",
      "en" : "Your email",
    },
    passwordField : {
      "fr" : "Mot de passe",
      "en" : "Your password",
    },
    formValid : {
      "fr" : "Connexion",
      "en" : "Login",
    },
    createAccount : {
      "fr" : "Pas de compte ?",
      "en" : "No account ?",
    },
    forgotPassword : {
      "fr" : "Mot de passe oublié",
      "en" : "Forgotten password",
    },
    eduServ : {
      "fr" : "Se connecter avec EduServices",
      "en" : "Login with EduServices",
    },
  },
  errorLogin : { //errorLogin page
    title : {
      "fr": "Une erreur est survenue",
      "en" : "An error has occurred",
    },
    texte : {
      "fr" : "Nous sommes désolés mais votre compte n’existe pas. Rapprochez vous de votre école pour leur signaler ce problème et qu’il puisse créer votre compte rapidement.",
      "en" : "We're sorry but your account does not exist. Contact your school to report this problem to them so they can create your account quickly.",
    },
    button : {
      "fr" : "Retour",
      "en" : "Back",
    },
  },
  forgotPassword : {//forgotPassword page
    title : {
      "fr" : "Mot de passe oublié",
      "en" : "Forgotten password",
    },
    emailField : {
      "fr" : "Votre email",
      "en" : "Your email",
    },
    formValid : {
      "fr" : "Réinitialiser",
      "en" : "Reset",
    },
    buttonMenu : {
      "fr" : "Connexion",
      "en" : "Login",
    },
    messageEnd : {
      "fr" : "Un email vous a été envoyé avec votre nouveau mot de passe.",
      "en" : "An email has been sent to you with your new password.",
    },
  },
  register : {//register page
    formValid : {
      "fr" : "Continuer",
      "en" : "Continue",
    },
    alreadyAccount : {
      "fr" : "Déjà un compte ?",
      "en" : "Already have an account ?",
    },
    nameField : {
      "fr" : "Votre nom",
      "en" : "Your name",
    },
    firstNameField : {
      "fr" : "Votre prénom",
      "en" : "Your first name",
    },
    lastNameField : {
      "fr" : "Votre nom",
      "en" : "Your last name",
    },
    emailField : {
      "fr" : "Votre email",
      "en" : "Your email",
    },
    passwordField : {
      "fr" : "Mot de passe",
      "en" : "Your password",
    },
    language : {
      title : {
        "fr" : "Choisissez votre langue",
        "en" : "Choose your language",
      },
      subTitle : {
        "fr" : "Parce qu’elles étudient notre cognition ou en d’autre terme notre esprit.",
        "en" : "Because they study our cognition or in other words our mind.",
      },
    },
    code : {
      title : {
        "fr" : "Entrez le code groupe",
        "en" : "Enter group code",
      },
      field : {
        "fr" : "Votre code",
        "en" : "Your code",
      },
    },
    infos : {
      title : {
        "fr" : "Entrez vos informations",
        "en" : "Enter your information",
      },
      subTitle : {
        "fr" : "Parce qu’elles étudient notre cognition ou en d’autre terme notre esprit.",
        "en" : "Because they study our cognition or in other words our mind.",
      },
      ruTexte : {
        "fr" : "J'accepte les ",
        "en" : "I agree to the ",
      },
      ruTitle : {
        "fr" : "conditions générales d'utilisation",
        "en"  : "terms of use"
      },
      verif : {
        title : {
          "fr" : "Vérifiez vos informations",
          "en" : "Check your information",
        },
        subTitle : {
          "fr" : "Tout changement ne sera plus possible dès lors que vous cliquez sur “Continuer”",
          "en" : "Any changes will no longer be possible once you click “Continue”",
        },
        closeText : {
          "fr" : "Retour",
          "en" : "Go back",
        },
        validText : {
          "fr" : "Continuer",
          "en" : "Continue",
        },
      },
    },
    formValid2 : {
      "fr" : "Inscription",
      "en" : "Register",
    },
    formValidUpdate : {
      "fr" : "Sauvegarder",
      "en" : "Save",
    },
  },
  dashboardMenu : {
    myAccount : {
      "fr" : "Mon Compte",
      "en" : "My Account",
    },
    help : {
      "fr" : "Centre d'Aide",
      "en" : "Help Center",
    },
    helpTitle : {
      "fr" : "Des difficultés ?",
      "en" : "Having troubles ?",
    },
    helpSubTitle : {
      "fr" : "Nous sommes là pour vous aider, cliquez ici",
      "en" : "We're here to assist you, click here",
    },
    logOut : {
      "fr" : "Déconnexion",
      "en" : "Logout",
    },
    backToDashboard : {
      "fr" : "Revenir au dashboard",
      "en" : "Go back to dashboard",
    },
    certifTitle : {
      "fr" : "Certification",
      "en" : "Certification",
    },
    certifSubTitle : {
      "fr" : "Le chemin vers la certification de tes soft skills",
      "en" : "The path to certifying your soft skills",
    },
  },
  onBoarding : {
    sexe : {
      "fr" : "Sexe",
      "en" : "Sexe",
    },
    age : {
      "fr" : "Age",
      "en" : "Age",
    },
    poste : {
      "fr" : "Nom entreprise/école",
      "en" : "Company/school name",
    },
    q2Rep1 : {
      "fr" : "Une femme",
      "en" : "A woman",
    },
    q2Rep2 : {
      "fr" : "Un homme",
      "en" : "A man",
    },
  },
  dashboard : {
    seeMore : {
      "fr" : "Voir plus",
      "en" : "See more",
    },
    globalScore : {
      "fr" : "Score Global",
      "en" : "Global Score",
    },
    download : {
      "fr" : "Télécharger",
      "en" : "Download",
    },
    shareResult : {
      "fr" : "Partage tes résultats",
      "en" : "Share your results",
    },
    welcomeTitle : {
      "fr" : "Bonjour ",
      "en" : "Hello ",
    },
    welcomeText : {
      "fr" : " effectuez le suivi de vos formations. Lancez-vous dès maintenant !",
      "en" : " follow up on your trainings. Get started now !",
    },
  },
  dashCarousel : {
    rattrapage : {
      "fr" : "Rattrapage",
      "en" : "Catch-up",
    },
    expertTitle : {
      "fr" : "Votre expert :",
      "en" : "Your expert :",
    },
    expertDesc : {
      "fr" : "Docteur en Neurosciences",
      "en" : "Doctor in Neurosciences",
    },
    progressText : {
      "fr" : "complété",
      "en" : "completed",
    },
    disponibleTo : {
      "fr" : "Disponible jusqu’au :",
      "en" : "Available until :",
    },
    disponible : {
      "fr" : "Disponible à partir du :",
      "en" : "Available from :",
    },
    closed : {
      "fr" : "Fermé depuis le :",
      "en" : "Closed since :",
    },
    daysLeft : {
      "fr" : "jours restants",
      "en" : "days left",
    },
    dayLeft : {
      "fr" : "jour restant",
      "en" : "day left",
    },
    button : {
      notify : {
        "fr" : "Me notifier",
        "en" : "Notify me",
      },
      results : {
        "fr" : "Voir résultats",
        "en" : "See results",
      },
      start : {
        "fr" : "Commencer",
        "en" : "Start",
      },
      resume : {
        "fr" : "Reprendre",
        "en" : "Resume",
      }
    },
    errorFormationID : {
      "fr": "Vous devez d’abord terminer le module précédent !",
      "en" : "You need to complete the previous module first !",
    },
  },
  dashStepper : {
    completed : {
      "fr" : "Complétée",
      "en" : "Completed",
    },
    inProgress : {
      "fr" : "En Cours",
      "en" : "In Progress",
    },
    closed : {
      "fr" : "Fermée",
      "en" : "Closed",
    },
    available : {
      "fr" : "Disponible",
      "en" : "Available",
    },
  },
  dashCertif : {
    title : {
      "fr" : "Ton chemin vers ta certification",
      "en" : "Your path to certification",
    },
    yearBtn : {
      "fr" : "Année ",
      "en" : "Year ",
    },
    btn : {
      "fr" : "Télécharge ton certificat",
      "en" : "Download your certificate",
    },
    pdfSubTitle : {
      "fr" : "Certifie les soft skills de ton diplôme",
      "en" : "Certify the soft skills of your diploma",
    },
    pdfMasterTitle : {
      "fr" : "Certificat de complétion",
      "en" : "Completion Certificate",
    },
    pdfSignature2 : {
      "fr" : "Directrice Scientifique de Rising Up",
      "en" : "Scientific Director of Rising Up",
    },
    pdfMasterText1 : {
      "fr" : "Ce certificat atteste que ",
      "en" : "This certificate certifies that ",
    },
    pdfMasterText2 : {
      "fr" : " a complété avec succès le programme Core Skills, validant les soft skills essentielles à l’obtention de son diplôme de ",
      "en" : " successfully completed the Core Skills program, validating the essential soft skills to obtaining their diploma ",
    },
    pdfMasterText3 : {
      "fr" : " Cette certification reconnaît l’engagement de ",
      "en" : " This certification recognizes the commitment of " ,
    },
    pdfMasterText4 : {
      "fr" : " dans le développement des soft skills nécessaires pour exceller dans un environnement professionnel en constante évolution. \n",
      "en" : " in the development of the necessary soft skills to excel in a constantly evolving professional environment.\n",
    },
    pdfMasterText5 : {
      "fr" : "Période de certification : ",
      "en" : "Certification period : ",
    },
    seuilCertif : {
      "fr" : "Seuil de certification",
      "en" : "Certification threshold",
    },
    catEfficacite : {
      "fr" : "Éfficacité\nopérationnelle",
      "en" : "Operational\nefficiency",
    },
    catInnovation : {
      "fr" : "Innovation et\ncommunication",
      "en" : "Innovation and\ncommunication",
    },
    catCollaboration : {
      "fr" : "Collaboration et\nleadership",
      "en" : "Collaboration and\nleadership",
    },
    certNotValidate : {
      "fr" : "Certification non validée",
      "en" : "Certification not validated",
    },
    pdfTextAvailableEnd : {
      "fr" : "Displonible à la fin de ton programme",
      "en" : "Available at the end of your program",
    },
    pdfTextRattrapage : {
      "fr" : "Malheureusement, tu n'as pas obtenu les résultats suffisants pour valider ta certification. Pas d'inquiétude, une session de rattrapage te sera proposée.",
      "en" : "Unfortunately, you did not obtain sufficient results to validate your certification. Don't worry, a catch-up session will be offered to you.",
    },
    pdfTextNotValidate : {
      "fr" : "Malheureusement, tu n'as pas obtenu les résultats suffisants pour valider ta certification.",
      "en" : "Unfortunately, you did not obtain sufficient results to validate your certification.",
    },
  },

  formation : {
    screenOrientationTitle : {
      "fr" : "Orientation de l'écran",
      "en" : "Screen orientation",
    },
    screenOrientationText : {
      "fr" : "Pour une meilleure expérience, nous vous conseillons d'utiliser votre appareil en mode paysage",
      "en" : "For a better experience, we advise you to use your device in landscape mode",
    },
    screenOrientationTextMobile : {
      "fr" : "Pour une meilleure expérience, nous vous conseillons d'utiliser votre appareil en mode portrait",
      "en" : "For a better experience, we advise you to use your device in portrait mode",
    },
    screenOrientationBtn : {
      "fr" : "Fermer",
      "en" : "Close",
    },
  },
  formatVideo : {
    resume : {
      "fr" : "Reprendre",
      "en" : "Resume",
    },
    replay : {
      "fr" : "Revoir la vidéo",
      "en" : "Watch again",
    },
    next : {
      "fr" : "Suivant",
      "en" : "Next",
    },
    play : {
      "fr" : "Lancer la vidéo !",
      "en" : "Start the video !",
    },
  },
  formatInscription : {
    nameFieldTitle : {
      "fr" : "Votre prénom",
      "en" : "Your firstname",
    },
    nameFieldPlaceholder : {
      "fr" : "Prénom",
      "en" : "Firstname",
    },
    nameFieldError : {
      "fr" : "Prénom invalide",
      "en" : "Invalid firstname",
    },
    emailFieldTitle : {
      "fr" : "Votre email",
      "en" : "Your email",
    },
    emailFieldError : {
      "fr" : "Email invalide",
      "en" : "Invalid email",
    },
  },
  formatDiagnostic : {
    loadingScore : {
      "fr" : "Nous sommes en train d’analyser vos résultats",
      "en" : "We are analyzing your results",
    },
  },
  formatQuizz : {
    goodAnswer : {
      "fr" : "Bonne Réponse",
      "en" : "Good Answer",
    },
    badAnswer : {
      "fr" : "Mauvaise Réponse",
      "en" : "Bad Answer",
    },
    textNoGoodAnswer : {
      "fr" : "Votre réponse a bien été prise en compte",
      "en" : "Your response has been taken into account",
    },
    btnNext : {
      "fr" : "Suivant",
      "en" : "Next",
    },
    btnValidate : {
      "fr" : "Valider",
      "en" : "Validate",
    },
    textMultipleResponses : {
      "fr" : "Plusieurs réponses sont possibles",
      "en" : "Several answers are possible"
    },
  },
  landingScore : {
    score : {
      "fr" : "Score de",
      "en" : "Score of",
    },
    sharing : {
      "fr" : "Challengez vos amis et voyez qui est le meilleur d’entre vous.",
      "en" : "Challenge your friends and see who is the best of you.",
    },
  },
  adminDashboard : {
    welcomeTitle : {
      "fr" : "Bonjour ",
      "en" : "Hello ",
    },
    welcomeText : {
      "fr" : "Bienvenue dans votre dashboard personnalisé. Vous allez pouvoir suivre en temps réel l’état d’avancement de vos groupes.",
      "en" : "Welcome to your personal dashboard. You can track your groups progress in real-time.",
    },
    watchTour : {
      "fr" : "Voir Tutoriel",
      "en" : "Watch Tour",
    },
    monitoring : {
      "fr" : "Suivi",
      "en" : "Monitoring",
    },
    monitoringSub : {
      "fr" : "Suivez en temps réel les résultats de votre groupe.",
      "en" : "Track your group's results in real-time."
    },
    mapping : {
      "fr" : "Mapping",
      "en" : "Mapping",
    },
    mappingSub : {
      "fr" : "Le mapping par secteur, par année de votre groupe.",
      "en" : "Map your group by sector and by year."
    },
    certification : {
      "fr" : "Certification",
      "en" : "Certification",
    },
    certificationSub : {
      "fr" : "La certification soft skills de votre diplôme.",
      "en" : "The soft skills certification for your diploma."
    },
    usedSoftSkills : {
      "fr" : "Soft Skills Utilisés",
      "en" : "Applied Soft Skills",
    },
    efficaciteSkills : {
      "fr" : "Efficacité opérationnelle",
      "en" : "Operational effectiveness",
    },
    communicationSkills : {
      "fr" : "Communication et innovation",
      "en" : "Communication and innovation",
    },
    leadershipSkills : {
      "fr" : "Leadership et collaboration",
      "en" : "Leadership and collaboration",
    },
    exportTable : {
      "fr" : "Exporter le tableau",
      "en" : "Export the data",
    },
    exportPDF : {
      "fr" : "Exporter le PDF",
      "en" : "Export the PDF",
    },
    completionChart : {
      title : {
        "fr" : "Total étudiants ayant fini…",
        "en" : "Total students who finished…",
      },
      average : {
        "fr" : "Total",
        "en" : "Total",
      },
    },
    monitoringCards : {
      students : {
        "fr" : "Étudiants total",
        "en" : "Total students",
      },
      modules : {
        "fr" : "Modules",
        "en" : "Modules",
      },
      completion : {
        "fr" : "Taux de complétion",
        "en" : "Completion rate",
      },
      average : {
        "fr" : "Moyenne groupe",
        "en" : "Group average",
      },
      softSkills : {
        "fr" : "Soft Skills",
        "en" : "Soft Skills",
      },
      time : {
        "fr" : "Moyenne temps passé",
        "en" : "Average time spent",
      }
    },
    monitoringTable : {
      oui : {
        "fr" : "Oui",
        "en" : "Yes",
      },
      non : {
        "fr" : "Non",
        "en" : "No",
      },
      rattrapage : {
        "fr" : " (R)",
        "en" : " (C)",
      },
      rattrapageExport : {
        "fr" : "Rattrapage",
        "en" : "Catch-up",
      },
      name : {
        "fr" : "Nom",
        "en" : "Name",
      },
      certification : {
        "fr" : "Certification",
        "en" : "Certification",
      },
      campus : {
        "fr" : "Campus",
        "en" : "Campus",
      },
      module : {
        "fr" : "Module",
        "en" : "Module",
      },
      score : {
        "fr" : "Statut",
        "en" : "Status",
      },
      moduleType : {
        "fr" : "Type de module",
        "en" : "Module type",
      },
      sector : {
        "fr" : "Nom de diplôme",
        "en" : "Diploma name",
      },
      studyYear : {
        "fr" : "Année d'étude",
        "en" : "Year of study",
      },
      graduationYear : {
        "fr" : "Année de certification",
        "en" : "Certification year",
      },
      statusProgress : {
        "fr" : "Complété à ",
        "en" : "Completed at "
      },
      statusNotStarted : {
        "fr" : "Pas commencé",
        "en" : "Not started"
      },
      statusEnded : {
        "fr" : "Terminé",
        "en" : "Ended"
      },
      graduation : {
        "fr" : "Diplôme",
        "en" : "Graduation",
      },
      level : {
        "fr" : "Statut",
        "en" : "Status",
      },
      progress : {
        "fr" : "Progression",
        "en" : "Progression",
      },
    },
    mappingCards : {
      students : {
        "fr" : "Nombre d’étudiants",
        "en" : "Number of students",
      },
      sectors : {
        "fr" : "Nombre de certifications",
        "en" : "Number of certifications",
      },
      softSkills : {
        "fr" : "Nombre de Soft Skills",
        "en" : "Number of Soft Skills",
      },
      date : {
        "fr" : "En date du",
        "en" : "Date",
      },
    },
    mappingCanvas : {
      title : {
        "fr" : "Niveau de connaissances",
        "en" : "Knowledge level",
      },
      textG : {
        "fr" : "Avant la formation",
        "en" : "Before the training",
      },
      textD : {
        "fr" : "Après la formation",
        "en" : "After the training",
      },
      pdfBefore : {
        "fr" : "Avant",
        "en" : "Before",
      },
      pdfAfter : {
        "fr" : "Après",
        "en" : "After",
      },
      formation : {
        "fr" : "la formation",
        "en" : "the training",
      },
      viewMoreBtn : {
        "fr" : "Voir plus",
        "en" : "View more",
      },
      viewLessBtn : {
        "fr" : "Voir moins",
        "en" : "View less",
      },
      seuil : {
        "fr" : "Seuil",
        "en" : "Limit",
      },
      groupAverage : {
        "fr" : "Moyenne du groupe",
        "en" : "Group average"
      },
      lowestScore : {
        "fr" : "Score le plus bas",
        "en" : "Lowest score"
      },
      highestScore : {
        "fr" : "Score le plus haut",
        "en" : "Highest score"
      },
      seuilOKLegend : {
        "fr" : "Seuil atteint",
        "en" : "Limit reached",
      },
      seuilPasOKLegend : {
        "fr" : "Seuil non atteint",
        "en" : "Limit not reached",
      },
      niveauDepartLine1 : {
        "fr" : "Niveau moyen",
        "en" : "Average",
      },
      niveauDepartLine2 : {
        "fr" : "de départ",
        "en" : "starting level",
      },
      niveauEscompteLine1 : {
        "fr" : "Niveau",
        "en" : "Expected",
      },
      niveauEscompteLine2 : {
        "fr" : "escompté",
        "en" : "level",
      },
    },
    filters : {
      addFilter : {
        "fr" : "Ajouter Filtre",
        "en" : "Add Filter",
      },
      deleteAll : {
        "fr" : "Tout supprimer",
        "en" : "Remove all",
      },
      delete : {
        "fr" : "Vider",
        "en" : "Clear",
      },
      moduleName : {
        "fr" : "Nom du module",
        "en" : "Module name",
      },
      moduleNameSub : {
        "fr" : "Formations",
        "en" : "Training",
      },
      moduleType : {
        "fr" : "Type de module",
        "en" : "Module type",
      },
      moduleTypeSub : {
        "fr" : "Types",
        "en" : "Types",
      },
      studyYear : {
        "fr" : "Année d'étude",
        "en" : "Year of study",
      },
      studyYearSub : {
        "fr" : "Années d'études",
        "en" : "Years of study",
      },
      graduationYear : {
        "fr" : "Année de certification",
        "en" : "Certification year",
      },
      graduationYearSub : {
        "fr" : "Années de Certification",
        "en" : "Certification years",
      },
      groupe : {
        "fr" : "Certification",
        "en" : "Certification",
      },
      groupeSub : {
        "fr" : "Certifications",
        "en" : "Certifications",
      },
      campus : {
        "fr" : "Campus",
        "en" : "Campus",
      },
      campusSub : {
        "fr" : "Campus",
        "en" : "Campus",
      },
      sector : {
        "fr" : "Nom de diplôme",
        "en" : "Diploma name",
      },
      sectorSub : {
        "fr" : "Noms de diplôme",
        "en" : "Diploma names",
      },
      status : {
        "fr" : "Statut",
        "en" : "Status",
      },
      statusSub : {
        "fr" : "Statut",
        "en" : "Status",
      },
      level : {
        "fr" : "Statut",
        "en" : "Status",
      },
      levelSub : {
        "fr" : "Statut",
        "en" : "Status",
      },
      progress : {
        "fr" : "Progression",
        "en" : "Progression",
      },
      progressSub : {
        "fr" : "Progression",
        "en" : "Progression",
      },
    },
    contentType : {
      identif : {
        "fr" : "Évaluation",
        "en" : "Evaluation",
      },
      enrich : {
        "fr" : "Enrichissement",
        "en" : "Enrichment",
      },
      icebreaker : {
        "fr" : "Icebreaker",
        "en" : "Icebreaker",
      }
    },
    statusTypes : {
      notStarted : {
        "fr" : "Pas commencé",
        "en" : "Not started",
      },
      inProgress : {
        "fr" : "En cours",
        "en" : "In progress",
      },
      ended : {
        "fr" : "Terminé",
        "en" : "Finished",
      },
      endedInRat : {
        "fr" : "Terminé (R)",
        "en" : "Finished (C)",
      }
    },
    levelTypes : {
      notAcquired : {
        "fr" : "Non acquis",
        "en" : "Not acquired",
      },
      inProgress : {
        "fr" : "En cours",
        "en" : "In progress",
      },
      acquired : {
        "fr" : "Acquis",
        "en" : "Acquired",
      },
      rattrapage : {
        "fr" : "Rattrapage",
        "en" : "Retake",
      }
    },
    blockModal : {
      title : {
        "fr" : "Débloquez la fonctionnalité",
        "en" : "Upgrade to",
      },
      feature : {
        "fr" : "Fonctionnalité",
        "en" : "Feature",
      },
      subTitle : {
        mapping : {
          "fr" : "Le Mapping soft skills de votre groupe",
          "en" : "The soft skills mapping of your group",
        },
        certification : {
          "fr" : "La certification soft skills de votre diplôme",
          "en" : "The soft skills certification for your diploma",
        },
      },
      card1 : {
        mapping : {
          "fr" : "Découvrez les progrès des étudiants sur leurs connaissances en soft skills",
          "en" : "Discover students’ progress on their soft skills knowledge.",
        },
        certification : {
          "fr" : "Accédez à vos certifications soft skills par diplôme et par année.",
          "en" : "Access your soft skills certifications by degree and by year.",
        },
      },
      card2 : {
        mapping : {
          "fr" : "Cartographier les soft skills de vos étudiants par secteur et année d’études.",
          "en" : "Map your students' soft skills by sector and by the year of study.",
        },
        certification : {
          "fr" : "Retrouvez vos open badges par soft skills et par diplôme.",
          "en" : "Find your open badges with the help of the soft skills and degree.",
        },
      },
      button : {
        "fr" : "Contactez les commerciaux",
        "en" : "Contact Sales Team",
      },
    },
    certification : {
      "fr" : "Certification",
      "en" : "Certification",
    },
  },
}

const defaultState = {
  language : null,
  isLoading : false,
  values : values,
  changeLanguage: () => {},
}

const LanguageContext = React.createContext(defaultState)

class LanguageProvider extends Component {

  state = {
    language : null,
    isLoading : false,
    values : values,
  }

  changeLanguage = (lang) => {
    this.setState({
      language : lang
    })
  }



  componentDidMount() {
    let detectLanguage = detectBrowserLanguage()
    let language = "en"
    if (detectLanguage.includes("fr-")) {
      language = "fr"
    }
    this.setState({
      language : language,
      isLoading : true
    });

  }

  componentWillUpdate = (nextProps) => {
    if (this.props.auth.isAuthenticated === true) {
      if (this.props.user.language) {
        if (this.props.user.language !== this.state.language) {
          this.setState({
            language : this.props.user.language,
            isLoading : true
          });
        }
      }
    } else {
      let detectLanguage = detectBrowserLanguage()
      let language = "en"
      if (detectLanguage.includes("fr-")) {
        language = "fr"
      }
      if (language !== this.state.language) {
        this.setState({
          language : language,
          isLoading : true
        });
      }
    }
  }


  render() {
    const { children } = this.props
    return (
      <>
        {this.props.auth.isAuthenticated === true ? (
          <SocketContext.Provider value={socket}>
            <LanguageContext.Provider
              value={{
                language: this.state.language,
                isLoading: this.state.isLoading,
                values : this.state.values,
                changeLanguage : this.changeLanguage,
              }}
            >
              {children}
            </LanguageContext.Provider>
          </SocketContext.Provider>
        ) : (
          <LanguageContext.Provider
            value={{
              language: this.state.language,
              isLoading: this.state.isLoading,
              values : this.state.values,
              changeLanguage : this.changeLanguage,
            }}
          >
            {children}
          </LanguageContext.Provider>
        )}
      </>
  )
  }
}

const mapStateToProps = (state) => {
  return {
    auth : state.auth,
    user : state.user,
  }
}

export default LanguageContext

const LanguageProvider2 = connect(
  mapStateToProps
)(LanguageProvider)

export { LanguageProvider2 }
